import StorageCalculation from './StorageCalculation';
import BitRateCalculation from './BitRateCalculation';

const TierString = ({ tier, index, storageByTier, storageUnits }) => {
  let tierString = '';
  tierString += `Tier ${index + 1} \n`;
  tierString += `Raster : ${tier.resolution} \n`;
  tierString += `Codec : ${tier.label} \n`;
  tierString += `BitRate : ${tier.bit_rate} Mbps \n`;
  tierString += `Size : ${storageByTier} ${storageUnits.label} \n`;
  tierString += `\n`;
  return tierString;
};

const RecordDurationToString = (days, hours, minutes) => {
  let recordDurationString = '';
  recordDurationString += `${days} ${days === 1 ? 'Day ' : 'Days '}`;
  recordDurationString += `${hours} ${hours === 1 ? 'Hour ' : 'Hours '}`;
  recordDurationString += `${minutes} ${minutes === 1 ? 'Minute ' : 'Minutes '}`;
  return recordDurationString;
};

const GetStringToShareInformation = ({ frameRate, audioTracks, camsQty, storageResult, storageUnits, days, hours, minutes, tierList }) => {
  let storageByTier = 0;

  const UpdateValue = (value) => {
    storageByTier = value;
  };

  let informationToShare = '';
  informationToShare += `Frame Rate : ${frameRate.label} \n`;
  informationToShare += `Audio Tracks : ${audioTracks.value} \n`;
  informationToShare += `Cameras Number : ${camsQty.label}  \n`;
  informationToShare += `Record Duration : ${RecordDurationToString(days, hours, minutes)}\n`;
  informationToShare += `Total Storage : ${storageResult} ${storageUnits.label}\n`;
  informationToShare += `\n`;

  tierList.forEach((tier, index) => {
    let bitRateTotal = BitRateCalculation(tier, audioTracks, camsQty);
    UpdateValue(StorageCalculation({ days, hours, minutes, bitRateTotal, storageUnits }));
    informationToShare += TierString({ tier, index, storageByTier, storageUnits });
  });
  return informationToShare;
};

const GetTransferTimeStringToShareInformation = ({ storage, storageUnits, interfaceType, speedUnits, transferTimeResult }) => {
  let informationToShare = '';
  informationToShare += `Storage Size : ${storage} ${storageUnits.label}\n`;
  informationToShare += `Preset speed : ${interfaceType.label}\n`;
  informationToShare += `Speed : ${interfaceType.value} ${speedUnits.label}\n`;
  informationToShare += `Transfer Time : ${RecordDurationToString(transferTimeResult.days, transferTimeResult.hours, transferTimeResult.minutes)}`;

  return informationToShare;
};

export { GetStringToShareInformation, GetTransferTimeStringToShareInformation };
